import * as ComponentsDb from './componentsdb.js';
import { merge, zip, map, cloneDeep } from 'lodash';
import Treeutil from './treeutil.js';
const uuid = require('uuid');

function Partutil({from,source,gamedata,root}) {
  this.from = from;
  this.source = source;
  this.gamedata = gamedata;
  this.root = root;

  this.buildComponentCache();

  this.selectedLayer = {
    id: 'default'
  }
}

Partutil.prototype.selectLayer = function (layer) {
  this.selectedLayer = layer;
  if (!this.from.layers[layer.id]) {
    this.from.layers[layer.id] = cloneDeep(layer);
  }
}

Partutil.prototype.internalRemoveComponentsAndLinks = function (componentsToRemove, linksToRemove) {
  const treeutil = new Treeutil(this.from);
  treeutil.removeComponentsAndLinks(componentsToRemove, linksToRemove);
}
Partutil.prototype.findComponentForTransform = function (transform) {
  return this.getComponentById(transform.cid);
}

Partutil.prototype.getComponentIdxById = function (id) {
  return this.componentIdxById[id];
}

Partutil.prototype.getComponentById = function (id) {
  const c = this.componentsById[id];
  if (c) {
    return c;
  } else {
    return this.from.components.find( (c) => {
      return c.id === id;
    });
  }
}

Partutil.prototype.findParent = function (forTransform, parents=this.from.transforms) {

  for (let i = 0; i < parents.length; i++) {
    const transform = parents[i];
    if (transform.id === forTransform.id) {
      return transform;
    }
  };
  if (!parent) {
    for (let i = 0; i < parents.length; i++) {
      const transform = parents[i];
      const parent = this.findAllChildrenFromTransform(forTransform, transform);
      if (parent) {
        return parent;
      }
    }
  }
}

Partutil.prototype.findAllChildren = function (allChildren=[]) {
  this.buildComponentCache();
  this.from.transforms.forEach( (transform) => {
    this.findAllChildrenFromTransform(transform, allChildren);
  });
  return allChildren;
}
Partutil.prototype.findTransformById = function (in_id) {
  return this.findAllChildren().filter( ({id}) => {
    return id === in_id;
  })[0];
}

Partutil.prototype.getTransformsByLayer = function (layerId) {
  return this.findAllChildren()
    .filter( (transform) => {
      return transform.transform.layer === layerId;
    });
}

Partutil.prototype.findChildrenFromTransform = function (transform, allChildren=[]) {
  if (transform !== this.root) {
    allChildren.push(transform);
  }
    //parent = this.from.transforms;
  (transform === this.root ? this.from.transforms : transform.children).forEach( (child) => {
    this.findChildrenFromTransform(child, allChildren);
  });

  return allChildren;
}

Partutil.prototype.findAllChildrenFromTransform = function (transform, allChildren=[]) {
  allChildren.push(transform);
  if (!transform) {
    console.error('invalid transform');
    return [];
  }
  const component = this.findComponentForTransform(transform);
  if (!component) {
    console.error('lost a component');
    return [];
  }
  if (component.type === 'toy') {
    const toy = this.gamedata.getToyById(component.tid);
    const toyPartutil = new Partutil(toy);
    toy.transforms.forEach( (t) => {
      toyPartutil.findAllChildrenFromTransform(t, allChildren);
    });

  }
  transform.children.forEach( (child) => {
    this.findAllChildrenFromTransform(child, allChildren);
  });

  return allChildren;
}
Partutil.prototype.findHighestZindex = function (layer) {
  let highestZindex = -99999999;
  this.gamedata.findAllTransforms().forEach( (transform) => {
    if (transform.transform.layer === layer.id) {
      highestZindex = Math.max(highestZindex, transform.transform.zIndex);
    }
  });
  return Math.max(highestZindex,0);
}
Partutil.prototype.createChild = function (parent) {
  if (!this.selectedLayer) {
    throw new Error('select a layer');
  }
  let newChild = {
    id: uuid.v4(),
    name: '',
    transform: {
      layer: this.selectedLayer.id,
      pos: {
        x:1,
        y:1
      },
      scale: {
        x:1,
        y:1,
      },
      localScale: {
        x:1,
        y:1,
      },
      rotation: 0,
      localRotation: 0,
      alpha: 1,
      zIndex: this.findHighestZindex(this.selectedLayer) + 1,
      anchor: {
        x:0.5,
        y:0.5
      }
    },
    variables: [],
    vars: {},
    children: []
  }

  if (parent && parent !== this.root) {
    const parentComponent = this.findComponentForTransform(parent);
    const parentType = parentComponent.type;
    if (ComponentsDb.types[parentType].createChild) {
      newChild = merge(newChild, ComponentsDb.types[parentType].createChild(parentComponent));
    }
  }

  return newChild;

}
Partutil.prototype.addChild = function (in_parent, component) {
  let parent = in_parent;
  if (!in_parent  || in_parent.id === 'root') {
    parent = this.from.transforms;
  } else {
    parent = in_parent.children;
  }

  const newChild = this.createChild(in_parent);
  const newComponent = this.addComponent(component);

  newChild.cid = newComponent.id;
  parent.push(newChild);

  return {
    newChild,
    newComponent
  }
}

Partutil.prototype.addChildren = function (in_parents, component) {
  const newChildren = [];
  const newComponents = [];
  const newParents = [];
  in_parents.forEach( (in_parent) => {
    let parent = in_parent;
    if (!in_parent  || in_parent.id === 'root') {
      parent = this.from.transforms;
    } else {
      parent = in_parent.children;
    }

    const newChild = this.createChild(in_parent);
    const newComponent = this.addComponent(component);

    newChild.cid = newComponent.id;
    parent.push(newChild);

    newChildren.push(newChild);
    newComponents.push(newComponent);
    newParents.push(in_parent);

  });
  return {
    newChildren,
    newComponents,
    newParents
  }
}


Partutil.prototype.addTransformsAndStuff = function (in_parents, transforms, components, links) {

  zip(in_parents, transforms).forEach( ([in_parent, child]) => {
    let parent = in_parent;
    if (in_parent.id === this.root.id) {
      parent = this.from.transforms;
    } else {
      // TODO: something else is not calling refresh cache when adding :-(
      this.buildComponentCache();
      parent = in_parent.children;
      const parentComponent = this.findComponentForTransform(in_parent);
      if (parentComponent) {
        const parentType = parentComponent.type;
        if (ComponentsDb.types[parentType].createChild) {
          child = merge(child, ComponentsDb.types[parentType].createChild(parentComponent));
        }
      } else {
        console.warn('TODO: parent component not found');
      }

    }
    parent.push(child);
  });

  components.forEach( (c) => {
    this.from.components.push(c);
  });

  links.forEach( (l) => {
    this.from.links.push(l);
  });

  this.buildComponentCache();

  return {
    addedParents: in_parents,
    addedChildren: transforms,
    addedComponents: components,
    addedLinks: links,
  }

}

Partutil.prototype.findComponentsForTransforms = function (transforms) {
  const cids = new Set(map(transforms, "cid"));

  return this.from.components.filter( (c) => {
    return cids.has(c.id);
  });

  
}

Partutil.prototype.findComponentsAndLinksFrom = function (component, data={components:[],links:[]}) {
  if (!component) {
    return;
  }
  data.components.push(component);
  const linksFromHere = this.from.links.filter( (l) => {
    return l.source === component.id;
  });
  linksFromHere.forEach( (l) => {
    data.links.push(l);
  });

  const componentsAtTarget = linksFromHere.map( (l) => {
    return this.getComponentById(l.target);
  });

  componentsAtTarget.forEach( (c) => {
    this.findComponentsAndLinksFrom(c, data);
  });

  return data;
}

Partutil.prototype.findComponentsAndLinksFromTransforms = function (transforms) {
  const componentsAndLinks = {components:[], links:[]};
  const childrenComponents = this.findComponentsForTransforms(transforms);

  childrenComponents.forEach( (component) => {
    this.findComponentsAndLinksFrom(component, componentsAndLinks);
  });

  return componentsAndLinks;
}

Partutil.prototype.findComponentsAndLinksFromTransform = function (transform) {
  const childrenTransforms = this.findChildrenFromTransform(transform);
  return this.findComponentsAndLinksFromTransforms(childrenTransforms);
}

Partutil.prototype.paste = function (in_parent, {components, links, transforms, parent}) {


  if (!parent) {
    const child = transforms[0];
    const newComponents = components.map(this.copyComponent.bind(this));
    const newLinks = links.map(this.copyLink.bind(this));

    const componentsMap = {};
    zip(components, newComponents).forEach( ([oldComponent, newComponent]) => {
      componentsMap[oldComponent.id] = newComponent;
    });

    newLinks.forEach( (link) => {
      const source = components.find( (c) => {
        return link.source === c.id;
      });
      const target = components.find( (c) => {
        return link.target === c.id;
      });

      link.source = componentsMap[source.id].id;
      link.target = componentsMap[target.id].id;
    });

    const newChild = this.copyChild(child, componentsMap);

    const {addedChildren, addedComponents, addedLinks, addedParents} = this.addTransformsAndStuff([in_parent], [newChild], newComponents, newLinks);

    return {
      type:'paste',
      addedParents,
      addedChildren,
      addedComponents,
      addedLinks
    }
  } else {
    const {removedChild, removedComponent, removedComponents, removedLinks, removedParents} = this.removeTransforms([{parent, child:transforms[0]}]);
    const {addedChildren, addedComponents, addedLinks, addedParents} = this.addTransformsAndStuff([in_parent], transforms, components, links);
    return {
      type:'cut',
      removedChild, removedComponent, removedComponents, removedLinks, removedParents,
      addedChildren, addedComponents, addedLinks, addedParents
    }
  }


}

Partutil.prototype.copy = function (in_parent, child) {
  const {components,links} = this.findComponentsAndLinksFromTransform(child);
  const transforms = [cloneDeep(child)];

  return {
    components,
    links,
    transforms
  }
}

Partutil.prototype.cut = function (in_parent, child) {
  const {components,links} = this.findComponentsAndLinksFromTransform(child);
  const transforms = [cloneDeep(child)];

  return {
    parent:in_parent,
    components,
    links,
    transforms
  }
}


Partutil.prototype.duplicateChild = function (in_parent, child) {
  const {components,links} = this.findComponentsAndLinksFromTransform(child);

  const newComponents = components.map(this.copyComponent.bind(this));
  const newLinks = links.map(this.copyLink.bind(this));

  const componentsMap = {};
  zip(components, newComponents).forEach( ([oldComponent, newComponent]) => {
    componentsMap[oldComponent.id] = newComponent;
  });

  newLinks.forEach( (link) => {
    const source = components.find( (c) => {
      return link.source === c.id;
    });
    const target = components.find( (c) => {
      return link.target === c.id;
    });

    link.source = componentsMap[source.id].id;
    link.target = componentsMap[target.id].id;
  });

  const newChild = this.copyChild(child, componentsMap);
  newChild.transform.pos.x += 1;
  newChild.transform.pos.y += 1;

  //parent.push(newChild);

  const {addedChildren, addedComponents, addedLinks} = this.addTransformsAndStuff([in_parent], [newChild], newComponents, newLinks);

  this.buildComponentCache();

  return {
    newChild:addedChildren[0],
    newComponents:addedComponents,
    newLinks:addedLinks
  }
}

Partutil.prototype.duplicateAndLink = function (in_parent, child) {
  let parent;
  if (!in_parent  || in_parent.id === 'root') {
    parent = this.from.transforms;
  } else {
    parent = in_parent.children;
  }
  const component = this.findComponentForTransform(child);
  const addedChild = cloneDeep(child);
  addedChild.children = [];
  addedChild.id = uuid.v4();
  addedChild.cid = component.id;
  addedChild.transform.pos.x += 1;
  addedChild.transform.pos.y += 1;
  parent.push(addedChild);
  return {addedChild};
}
Partutil.prototype.duplicateAndLinkChildren = function (lst) {
  const addedChildren = [];
  const addedParents = [];
  lst.forEach( ({parent, child}) => {
    const {addedChild} = this.duplicateAndLink(parent, child);
    addedChildren.push(addedChild);
    addedParents.push(parent);
  });

  return {
    addedChildren,
    addedParents
  }
}


Partutil.prototype.copyComponent = function (component) {
  const newComponent  = cloneDeep(component);
  newComponent.id = uuid.v4();
  return newComponent;
}
Partutil.prototype.copyLink = function (link) {
  const newLink = cloneDeep(link);
  newLink.id = uuid.v4();
  return newLink;
}
Partutil.prototype.copyChild = function (child, componentsMap) {
  const newChild = cloneDeep(child);

  const newTransforms = this.findChildrenFromTransform(newChild);
  newTransforms.forEach( (t) => {
    t.id = uuid.v4();
    t.cid = componentsMap[t.cid].id;
    if (typeof(t.transform.layer) === 'undefined') {
      t.transform.layer = this.selectedLayer.id;
    }

  });

  if (typeof(newChild.transform.layer) === 'undefined') {
    newChild.transform.layer = this.selectedLayer.id;
  }

  return newChild;
}

Partutil.prototype.duplicateChildren = function (lst) {
  let addedChildren = [];
  let addedParents = [];
  let addedLinks = [];
  let addedComponents = [];

  lst.forEach( ({parent, child}) => {
    const {newChild, newComponents, newLinks} = this.duplicateChild(parent, child);
    addedParents.push(parent);
    addedChildren.push(newChild);
    addedComponents = addedComponents.concat(newComponents);
    addedLinks = addedLinks.concat(newLinks);
  });

  return {
    addedChildren,
    addedParents,
    addedLinks,
    addedComponents
  }
}

Partutil.prototype.findReferenceCount = function (component) {
  return this.findAllChildren().filter( ({cid}) => {
    return cid === component.id;
  }).length;
}

Partutil.prototype.addParentToTransform = function (transform, newParentComponent) {
  const possible_parents = this.getParentsForTransform(transform);
  let parent;
  if (possible_parents.length) {
    const len = possible_parents.length;
    parent = possible_parents[len - 1];
  } else {
    parent = this.root;
  }
  

  let parents = parent.children;
  if (!parent || parent.id === 'root') {
    parents = this.from.transforms;
  }

  const index = parents.findIndex( (t) => {
    return transform.id === t.id;
  });
  const removedChild = parents[index];
  parents.splice(index, 1);

  const {newChild} = this.addChild(parent, newParentComponent);
  newChild.transform.pos.x = transform.transform.pos.x;
  newChild.transform.pos.y = transform.transform.pos.y;
  newChild.transform.layer = transform.transform.layer;

  const {addedChildren, addedComponents, addedLinks} = this.addTransformsAndStuff([newChild], [removedChild], [], []);
  removedChild.transform.pos.x = 0;
  removedChild.transform.pos.y = 0;
  removedChild.transform.layer = transform.transform.layer;

}

Partutil.prototype.removeChild = function (parent, child) {
  let parents = parent.children;
  if (!parent || parent.id === 'root') {
    parents = this.from.transforms;
  }

  const component = this.findComponentForTransform(child);
  const refCount = this.findReferenceCount(component);

  const index = parents.findIndex( (t) => {
    return child.id === t.id;
  });
  const removedChild = parents[index];
  parents.splice(index, 1);

  if (refCount <= 1) {
    const {components,links} = this.findComponentsAndLinksFromTransform(child);

    const componentIdxs = components.map( (c) => {
      return parseInt(this.getComponentIdxById(c.id));
    });
    componentIdxs.sort( (a,b) => { return a-b } );
    for (let i = componentIdxs.length - 1; i >= 0; i--) {
      const idx = componentIdxs[i];
      this.from.components.splice(idx, 1);
    }
    const removedComponent = components[0];

    this.buildComponentCache();

    return {
      removedChild,
      removedComponent,
      removedComponents:components,
      removedLinks:links
    };

  } else {
    this.buildComponentCache();
    return {
      removedChild,
      removedComponent:undefined,
      removedComponents:[],
      removedLinks:[]
    }
  }

}

Partutil.prototype.removeTransforms = function (lst) {
  let removedTransforms = [];
  let removedLinks = [];
  let removedChildren = [];
  let removedComponents = [];
  let removedParents = [];

  lst.forEach( ({parent, child}) => {
    const removedData = this.removeChild(parent, child);
    removedLinks = removedLinks.concat(removedData.removedLinks);
    removedComponents = removedComponents.concat(removedData.removedComponents);
    removedChildren = removedChildren.concat(removedData.removedChild);
    removedParents.push(parent);
  });

  this.buildComponentCache();
  return {
    removedLinks,
    removedChildren,
    removedComponents,
    removedTransforms,
    removedParents
  }
}

const DEFAULT_COMPONENTS = {
  sprite:{
    type:'sprite',
    sprite:'placeholder.png'
  },
  text: {
    type:'text',
    text:'Hi there'
  }
}

Partutil.prototype.addComponent = function (component) {
  if (typeof(component.id) === 'undefined') {
    component.id = uuid.v4();
  }
  this.from.components.push(component);
  this.buildComponentCache();
  return component;
}
Partutil.prototype.createComponent = function (type) {
  const component = ComponentsDb.types[type].createNew();
  component.id = uuid.v4();
  this.from.components.push(component);
  this.buildComponentCache();

  return component;
}

Partutil.prototype.buildComponentCache = function () {
  this.componentIdxById = {};
  this.componentsById = {};
  for (let i = 0; i < this.from.components.length; i++) {
    const c = this.from.components[i];
    this.componentIdxById[c.id] = i;
    this.componentsById[c.id] = c;
  }
}

Partutil.prototype.addFromPack = function ({image,spritesheet,layer,position,autotoys,renderTools,creator}, callback) {
  this.selectLayer(layer);
  const newComponent = creator(spritesheet, image);
  const {
    newChildren,
    newParents,
    newComponents,
  } = this.addChildren([this.root], newComponent);

  newChildren.forEach( (child) => {
    child.transform.pos.x = position.x;
    child.transform.pos.y = position.y;
  });

  const treeutil = new Treeutil(this.from);
  (autotoys||[]).forEach( ({name,components,transform}) => {
    (components||[]).forEach( (c) => {
      const component = JSON.parse(c);
      const newComponent = ComponentsDb.createComponent(component.type, component);
      Object.assign(newComponent, component);
      const {addedComponents,addedLinks} = treeutil.addComponentWithLinkData(newComponents[0], {name:'link'}, newComponent);
    });

    if (typeof(transform) !== 'undefined' && transform !== null) {
      const addedTransform = newChildren[0];
      if (transform.scalemethod) {
        renderTools.addOnReadyEvent(addedTransform, (holder) => {
          holder.scaleCover();
          renderTools.addToRunBatch( () => {
            renderTools.addToUpdateBatch(holder);
            renderTools.addToRunBatch( () => {
              const component = newComponent;
              const transform = addedTransform;
              console.log('callback with component', component);
              callback && callback({component,transform});
            });
          });
        });
      }

      if (transform.pos) {
        addedTransform.transform.pos.x = transform.pos.x;
        addedTransform.transform.pos.y = transform.pos.y;
      }
    }
  });


  return {
    newChildren,
    newParents,
    newComponents
  }

}

Partutil.prototype.addTilingSpriteFromSpritesheet = function ({image,spritesheet,layer,position,autotoys,renderTools}, callback) {
  const creator = (spritesheet, image) => {
    console.log('creaty tiley');
    const newComponent = ComponentsDb.types.tiledSprite.createNew();
    console.log('created tiley', newComponent, image);
    if (spritesheet) {
      Object.assign(newComponent, {
        atlas:spritesheet,
        texture:image.name,
        sprite:image.name,
        firstLoad:true
      });
    } else {
      Object.assign(newComponent, {
        texture:image.id,
        sprite:image.id,
        firstLoad:true
      });
      console.log('made component', newComponent);
    }
    return newComponent;
  }
  return this.addFromPack({
    image,
    spritesheet,
    layer,
    position,
    autotoys,
    renderTools,
    creator
  }, callback);

}
Partutil.prototype.addImageFromSpritesheet = function ({image,spritesheet,layer,position,autotoys,renderTools}, callback) {

  const creator = (spritesheet, image) => {
    const newComponent = ComponentsDb.types.sprite.createNew();
    if (spritesheet) {
      Object.assign(newComponent, {
        atlas:spritesheet,
        texture:image.name,
        sprite:image.name,
        firstLoad:true
      });
    } else {
      Object.assign(newComponent, {
        sprite:image.id,
        firstLoad:true
      });
    }
    return newComponent;
  }
  return this.addFromPack({
    image,
    spritesheet,
    layer,
    position,
    autotoys,
    renderTools,
    creator
  }, callback);
}

Partutil.prototype.getParentsForTransform = function (transform, root=undefined, parents=[]) {
  //parents.push(this.root);

  if (!root) {
    root = this.from.transforms;
  } else {
    root = root.children;
  }

  for (let i = 0; i < root.length; i++) {
    const possibleParent = root[i];
    if (possibleParent.id === transform.id) {
      return parents;
    }

    if (this.getParentsForTransform(transform, possibleParent, parents)) {
      parents.push(possibleParent);
      return parents;
    }
  }
}

Partutil.prototype.addSprite = function (parent, layer) {
  const newComponent = ComponentsDb.types.sprite.createNew();
  Object.assign(newComponent, {
    firstLoad:true
  });
  this.selectLayer(layer);
  const {
    newChildren,
    newParents,
    newComponents,
  } = this.addChildren([parent], newComponent);

  newChildren.forEach( (child) => {
    child.transform.pos.x = 0;
    child.transform.pos.y = 0;
  });

  return {newChildren, newParents, newComponents, sprite:newComponents[0]};
}


Partutil.prototype.addVideo = function (parent, layer) {
  const newComponent = ComponentsDb.types.video.createNew();
  Object.assign(newComponent, {
    firstLoad:true
  });
  this.selectLayer(layer);
  const {
    newChildren,
    newParents,
    newComponents,
  } = this.addChildren([parent], newComponent);

  newChildren.forEach( (child) => {
    child.transform.pos.x = 0;
    child.transform.pos.y = 0;
  });

  return {newChildren, newParents, newComponents, video:newComponents[0]};
}

Partutil.prototype.addToy = function (parent, in_toy, layer) {
  let toy = this.gamedata.getToyById(in_toy.id);
  if (!toy) {
    toy = this.gamedata.addToy(in_toy);
  } else {
    toy = toy.from;
  }

  this.selectLayer(layer);

  const toyComponent = ComponentsDb.types.toy.createNew();
  toyComponent.tid = toy.id;
  toyComponent.unparent = false;

  const {
    newChildren,
    newParents,
    newComponents,
  } = this.addChildren([parent], toyComponent);

  return {
    newChildren,
    newParents,
    newComponents
  }

}

Partutil.prototype.getTreeUtil = function () {
  return new Treeutil(this.from);
}


export default Partutil;

